import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import API, { methods } from '../canvas-api';
import { handleGenericError } from '../common';
import { actions } from '../../reducers/printers/printers';
import { prepareMachineSettingsData, sanitizePrinterData } from './common';

export default function* updatePrinter(action) {
  try {
    const { printerId, printerData } = action.payload;
    const machineSettings = prepareMachineSettingsData(
      printerData.machineSettings
    );

    const body = {
      ...machineSettings,
      tagId: printerData.tagId,
      modded: printerData.modded,
    };

    const response = yield call(API, {
      method: methods.POST,
      path: `printers/${printerId}`,
      body,
    });
    if (response === null) return;

    const sanitizedPrinter = sanitizePrinterData(response.printer);
    yield put(actions.updatePrinterSuccess(sanitizedPrinter));
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
